import { createFileRoute } from '@tanstack/react-router';
import { DetalheDaFicha } from '@/features/fichas/componentes/DetalheDaFicha';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Página da ficha com os exercícios (spec 008, CA-04). */
export const Route = createFileRoute('/_autenticado/fichas/$id')({
  ...rotaDeTela('fichas.lista'),
  component: Pagina,
});

function Pagina() {
  const { id } = Route.useParams();
  return <DetalheDaFicha key={id} id={id} />;
}
